class ImageUrlResizer {
  static resize(imageUrl, outputSize, crop = true, format?: string): string {
    if (imageUrl?.includes('images.')) {
      return ImageUrlResizer.resizeS3ImageByURL(imageUrl, outputSize, format, crop);
    }

    // eslint-disable-next-line
    const sTypeRegExp = /([=/])(s\d+)($|-)/;
    const szTypeRegExp = /sz=\d+/g;
    const sizeTypeRegExp = /type=\w+/g;

    // Covers urls with =s50, /s50-c/ and etc.
    if (imageUrl && imageUrl.match(sTypeRegExp)) {
      return imageUrl.replace(new RegExp(sTypeRegExp, 'gm'), `$1s${outputSize}$3`);
    }

    // Covers url with sz=
    if (imageUrl && imageUrl.match(szTypeRegExp)) {
      return imageUrl.replace(szTypeRegExp, `sz${outputSize}`);
    }

    // Covers type= urls
    if (imageUrl && imageUrl.match(sizeTypeRegExp)) {
      return imageUrl.replace(sizeTypeRegExp, `height=${outputSize}&width=${outputSize}`);
    }

    return imageUrl;
  }

  /**
   * Used to resize our S3 images.
   * @param url
   * @param size
   * @param format
   * @param crop
   */
  static resizeS3ImageByURL(url: string, size: number, format = 'jpeg', crop = true) {
    const imageURL = new URL(url);
    const resizeParams = new URLSearchParams();

    if (size) {
      resizeParams.append('s', size.toString());
    }

    if (format !== 'jpeg') {
      resizeParams.append('f', format);
    }

    if (!crop) {
      resizeParams.append('c', 'inside');
    }

    imageURL.search = `?${resizeParams.toString()}`;

    return imageURL.toString();
  }

  /**
   * Returns webp format image url instead
   */
  static toWebp(imageUrl: string) {
    // Do not change google urls
    if (!imageUrl?.includes('images.')) {
      return imageUrl;
    }

    const url = new URL(imageUrl);

    url.searchParams.delete('f');
    url.searchParams.append('f', 'webp');

    return url.toString();
  }
}

export default ImageUrlResizer;
